import {Component, Input} from '@angular/core'
import {MediaInterface} from '../../interfaces'

@Component({
  selector: 'dmmp-benefits-figures',
  templateUrl: './benefits-figures.component.html',
})
export class BenefitsFiguresComponent {
  @Input() data
  @Input() identifier

  medias: MediaInterface[] = [
    {style: 'thumbnail', media: '(min-width: 250px)'}
  ]

}
